import { useContext } from "react";
import { UserContext } from "../../../context-providers/user.provider";

export default function useMPPSubject() {
  const { landingSubject, setLandingSubject } = useContext(UserContext);
  return { mppSubject: landingSubject, updateMppSubject: setLandingSubject };
}
